// import React from "react";

import Slider from "react-slick";
// import { useGSAP } from "@gsap/react";
// import gsap from 'gsap'
// import Lenis from 'lenis'
// import { ScrollTrigger } from 'gsap/all';
// import SplitType from 'split-type'

// import ContactForm from '../component/form-contact';
import Header from "../component/header";
import Footer from "../component/footer";

// import about01 from '../assets/images/Homepage/Who_We_Are/b79bppl8rzz9ski60trk.webp'
// import about02 from '../assets/images/Homepage/Who_We_Are/qxpkqgdxswv6c6nrp0jo.webp'

import Founder from '../assets/images/AboutUS/Aboutus/FounderFocused.png'

// wallpaper
import aboutus from '../assets/images/About/fxx7dmwvwukr4b4wxpif.webp'
import howwework from '../assets/images/How-We-Work.webp'
// import banner01 from '../assets/images/About/v60tqblpw6nu1br1nmk7.webp'
import engineeringtrust from '../assets/images/AboutUS/About-us-1-Engineering-Trust.webp'
// import journey01 from '../assets/images/AboutUS/About-us-2-Engineering-Trust.webp'

import sustainability01 from "../assets/images/AboutUS/Aboutus/Sustainability-Responsibility-1.png"
import sustainability02 from "../assets/images/AboutUS/Aboutus/Sustainability-Responsibility-2.png"
import sustainability03 from "../assets/images/AboutUS/Aboutus/Sustainability-Responsibility-3.png"

import sustain01 from "../assets/images/Icons/Sustainability/efficient-material.webp"
import sustain02 from "../assets/images/Icons/Sustainability/Energy-conscious.webp"
import sustain03 from "../assets/images/Icons/Sustainability/Durable-long-life.webp"
import sustain04 from "../assets/images/Icons/Sustainability/Safe-working.webp"
import sustain05 from "../assets/images/Icons/Sustainability/ethical-sourcing.webp"


import manufacturing01 from "../assets/images/AboutUS/about-us-Manufacturing.webp"
import manufacturing02 from "../assets/images/AboutUS/about-us-Manufacturing-2.webp"

import manufacture01 from "../assets/images/Icons/Manufacturing/Skilled-TIG.webp"
import manufacture02 from "../assets/images/Icons/Manufacturing/Precision-forming.webp"
import manufacture03 from "../assets/images/Icons/Manufacturing/Strict-weld.webp"
import manufacture04 from "../assets/images/Icons/Manufacturing/Electropolishing.webp"
import manufacture05 from "../assets/images/Icons/Manufacturing/Tri-clamp.webp"
import manufacture06 from "../assets/images/Icons/Manufacturing/Documentation-traceability.webp"
import manufacture07 from "../assets/images/Icons/Manufacturing/Integrated-Process.webp"
import manufacture08 from "../assets/images/Icons/Manufacturing/End-to-End-Testing.webp"

// Video 
import video from '../assets/videos/videos02.mp4'


import AnimatedText from "../component/animation";
// import FadeInOnScroll from "../component/scrollanimation";




function About() {

   
 // // gasp


   
//    /////////// Carousel
       var settings = {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 5000,
      };
   

    return (
        <section>
            <Header/>
              <main>
                
                   <div className="section-title-center location-banner ">
                      {/* <img alt="" className="backgrouns-img" src="https://cdn.prod.website-files.com/63e0c726a8112a793bad80c9/63e213fc5fccf95af22ad1af_Background%20Banner.webp"/> */}
                    <div className="base-container w-container section-scroll-animation">
                        <h1>WHO WE ARE</h1>
                         <p className="_w-69"><AnimatedText text="At Arkane Engineering we design, fabricate, and install high-quality stainless-steel systems that keep your processes safe, efficient, and compliant with the highest industry standards. Whether building a new facility or upgrading an existing one, we deliver tailored solutions that optimize performance and future-proof your operations. 
                            From design to installation and ongoing support, we work alongside you at every step to ensure each system is engineered with precision, crafted with care, and aligned with your goals for long-term reliability and growth." animationType="fade-up" />
                            </p>
                    </div>
                   </div>
                
                 
                <div className="section-without-top-spacing first-story-section">
                     <img className="banner-img" alt={aboutus} src={aboutus}/>
                </div>
                 
            
             
                        <div className="section backgrounds-gray  object-container first-story-section animate-section-trigger">
          <div className="base-container w-container">

              <div className="w-layout-grid best-content-wrapper">
                  

                  <div className="best-content-wrap">
                      <div className="best-content">
                          <div>
                            <h2 className="primary-text"> <AnimatedText text="Engineering Trust. Delivering Precision." animationType="rotate" /></h2>
                            <p className="_w-69">
                               <AnimatedText text="Arkane Engineering is a Bangalore-based process engineering company that specializes in custom-built
                                stainless-steel systems for breweries, pharmaceuticals, food & beverage, chemical, and cosmetic industries." animationType="fade-up" />
                            </p>
                            <p className="_w-69">
                                <AnimatedText text="Founded in 2016, Arkane was built on a singular promise: to bring precision, performance, and reliability to
                                process plants of every scale. With decade of combined engineering experience and an agile, customer-first
                                culture, we’ve grown into a trusted partner for companies seeking end-to-end solutions — from design to commissioning." animationType="fade-up" />
                            </p>
                          </div>
                      </div>
                    
                  </div>

                  <div className="img-content">
                      <div className="img-container px-600">
                              <img src={engineeringtrust} alt="Bottle of beer" className="bottlebeer" />
                      </div>
                  </div>
              </div>
          </div>
      </div>
                
              
  
        
  
  <div className="section object-container section-scroll-animation animate-section-trigger">
          <div className="base-container w-container">

              <div className="w-layout-grid best-content-wrapper">
                  <div className="img-content">
              
                      <div className="img-container px-600">
                              <img src={howwework} alt="Bottle of beer" className="bottle-beer" />
                      </div>
                  </div>

                  <div className="best-content-wrap">
                          <h2><AnimatedText text="How We Work" animationType="scale"/></h2>
                      <div className="best-content center-block">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="Design with Purpose"animationType="scale"  /></h2>
                              <p className="_w-69">
                                  <AnimatedText text="We engineer every vessel, system, and process to the highest standards — ensuring
                                  reliable performance, durability, and quality you can trust. From raw materials to
                                  final testing, quality control is woven into every stage of manufacturing." animationType="fade-up" />
                              </p>
                          </div>
                          {/* <h5>01</h5> */}
                      </div>
                      <div className="best-content center-block">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="Fabricate with Precision" animationType="scale" /></h2>
                              <p className="_w-69">
                                  <AnimatedText text="Every facility is unique — and so is every solution we build. Whether it’s a microbrewery or a pharma-grade cleanroom system, we offer custom-designed
                                  systems tailored precisely to your operational and compliance requirements." animationType="fade-up" />
                              </p>
                          </div>
                          {/* <h5>02</h5> */}
                      </div>
                      <div className="best-content center-block">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="Deliver with Commitment" animationType="scale" /></h2>
                              <p className="_w-69"><AnimatedText text="From concept to commissioning, our team stays hands-on — ensuring quality, timelines, and performance expectations are consistently met." animationType="fade-up" />
                              </p>
                          </div>
                          {/* <h5>03</h5> */}
                      </div>
                     
                  </div>
              </div>
          </div>
      </div>
  
         
 
  <div className="section-without-top-spacing object-container first-story-section animate-section-trigger">
                <div className="base-container w-container">
                    <video className="image-full is--laptop top-y100" sizes="(max-width: 479px) 100vw, 98vw" autoPlay loop muted>
                        <source src={video} type='video/mp4' />
                    </video>
                    <div className="content-banner-home-1 tex-align-left">
                        <h2 className="primary-text"><AnimatedText text="Our Vision." animationType="rotate" /></h2>
                        <p className="banner-paragraph"><AnimatedText text="To build a global legacy of engineering excellence, becoming the first choice in advanced stainless-steel systems and inspiring trust through innovation, craftsmanship, and enduring client partnerships." animationType="fade-up" /></p>
                        {/* <div className="button-banner-wrap">
                            <a href="/contact-arkane" target="_blank" className="primary-button">Contact us Now</a>
                            </div> */}
                    </div>

                      <div className="content-banner-home-1 tex-align-right">
                        <h2 className="primary-text"><AnimatedText text="Our Mission." animationType="rotate" /></h2>
                        <p className="banner-paragraph"><AnimatedText text="Our mission is to transform industrial manufacturing through precision engineering, innovative stainless-steel solutions, and unwavering support in setting new benchmarks of excellence in every market we serve." animationType="fade-up" /></p>
                        {/* <div className="button-banner-wrap">
                            <a href="/contact-arkane" target="_blank" className="primary-button">Contact us Now</a>
                            </div> */}
                    </div>
                </div>
            </div>
 
      

 <div className="section object-container backgrounds-gray section-scroll-animation animate-section-trigger">
          <div className="base-container w-container">

              <div className="w-layout-grid best-content-wrapper">
                  <div className="img-content">
                  
                       <div className="img-container px-600">
                            <img src={Founder} alt={Founder} className="bottlebeer" />
                      </div>
                    
                    
                  </div>

                  <div className="best-content-wrap">
                      <div className="best-content">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="Founder Focused" nimationType="rotate" /></h2>
                              <p className="_w-69">
                                  <AnimatedText text="With years of hands-on experience in fabrication and piping, my passion for the process industry kept growing stronger. What began as a solo freelance venture offering stainless steel design and piping services which soon evolved as demand increased. To deliver more value and take on larger challenges, I was inspired to create a company that could bring ideas to life, combining thoughtful design with efficient project execution." nimationType="fade-up" />
                              </p>

                              <p className="_w-69">
                                  <AnimatedText text="As our projects expanded, so did the need for a skilled team and greater control over quality. This led us to set up our own manufacturing unit, ensuring precision, consistency, and timely delivery. What started as a one-person initiative has since grown into a dedicated organization built on expertise, commitment, and continuous innovation." nimationType="fade-up" />
                              </p>
                          </div>
                         
                      </div>
                    
                   
                  </div>
              </div>
          </div>
      </div>
  
     
     

 <div className="section object-container section-scroll-animation animate-section-trigger">
          <div className="base-container w-container">

              <div className="w-layout-grid best-content-wrapper">
                  <div className="img-content">
                  
                       <div className="img-container px-600">
                          <Slider {...settings}>
                               <img src={sustainability01} alt="Bottle of beer" className="bottle-beer" />
                               <img src={sustainability02} alt="Bottle of beer" className="bottle-beer" />
                               <img src={sustainability03} alt="Bottle of beer" className="bottle-beer" />
                          </Slider>
                      </div>
                    
                    
                  </div>

                  <div className="best-content-wrap Sustainability">
                      <div className="best-content">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="Sustainability & Responsibility" nimationType="rotate" /></h2>
                              <p className="_w-69">
                                  <AnimatedText text="We believe sustainability is not an afterthought, it is a responsibility.We prioritize:" nimationType="fade-up" />
                              </p>
                                    <div className="info-about-beer">
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                <img className="icon-responsive" src={sustain01} alt={sustain01}/>
                                            </div>
                                            <h4> <AnimatedText text="Efficient material usage and responsible scrap management" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                <img className="icon-responsive" src={sustain02} alt={sustain02}/>
                                            </div>
                                            <h4> <AnimatedText text="Energy-conscious fabrication practices and continuous process optimization" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                <img className="icon-responsive" src={sustain03} alt={sustain03}/>
                                            </div>
                                            <h4> <AnimatedText text="Durable, long-life equipment that reduces waste and operational inefficiency" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                <img className="icon-responsive" src={sustain04} alt={sustain04}/>
                                            </div>
                                            <h4> <AnimatedText text="Safe working environments and training for every technician" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                <img className="icon-responsive" src={sustain05} alt={sustain05}/>
                                            </div>
                                            <h4> <AnimatedText text="Ethical sourcing and environmentally aware decision-making" animationType="rotate" /></h4>
                                        </div>
                                        
                                    </div>
                              <p className="_w-69">
                                  <AnimatedText text="We aim to build equipment that not only performs exceptionally but also respects the world it operates in." nimationType="fade-up" />
                              </p>
                          </div>
                         
                      </div>
                    
                   
                  </div>
              </div>
          </div>
      </div>
  



  

 <div className="section object-container backgrounds-gray Manufacturing first-story-section animate-section-trigger">
          <div className="base-container w-container">

              <div className="w-layout-grid best-content-wrapper">
                  <div className="best-content-wrap">
                      <div className="best-content">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="Manufacturing Excellence" nimationType="rotate" /></h2>
                              <p className="_w-69">
                                  <AnimatedText text="At Arkane Engineering, our fabrication process is driven by:" nimationType="fade-up" />
                              </p>
                                    <div className="info-about-beer">
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                               <img className="icon-responsive" src={manufacture01} alt={manufacture01}/>
                                            </div>
                                            <h4> <AnimatedText text="Skilled TIG and sanitary welding" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                               <img className="icon-responsive" src={manufacture02} alt={manufacture02}/>
                                            </div>
                                            <h4> <AnimatedText text="Precision forming and finishing" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                               <img className="icon-responsive" src={manufacture03} alt={manufacture03}/></div>
                                            <h4> <AnimatedText text="Strict weld inspections and testing" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                               <img className="icon-responsive" src={manufacture04} alt={manufacture04}/>
                                            </div>
                                            <h4> <AnimatedText text="Electropolishing & passivation capabilities" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                               <img className="icon-responsive" src={manufacture05} alt={manufacture05}/>
                                            </div>
                                            <h4> <AnimatedText text="Tri-clamp and hygienic assembly systems" animationType="rotate" /></h4>
                                        </div>
                                         <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                               <img className="icon-responsive" src={manufacture06} alt={manufacture06}/>
                                            </div>
                                            <h4> <AnimatedText text="Documentation and traceability for regulated industries" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                              <img className="icon-responsive" src={manufacture07} alt={manufacture07}/>
                                           </div>
                                            <h4> <AnimatedText text="Integrated Process Automation Systems" animationType="rotate" /></h4>
                                        </div>
                                          <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                 <img className="icon-responsive" src={manufacture08} alt={manufacture08}/>
                                             </div>
                                            <h4> <AnimatedText text="End-to-End Testing & Validation for Guaranteed Reliability" animationType="rotate" /></h4>
                                        </div>
                                    </div>
                              <p className="_w-69">
                                  <AnimatedText text="We maintain rigorous quality checks at every step, ensuring every product reflects our promise of excellence." nimationType="fade-up" />
                              </p>
                          </div>
                      </div>
                  </div>


                   <div className="img-content">
                       <div className="img-container px-600  align-end">
                          <Slider {...settings}>
                            <img src={manufacturing01} alt="Bottle of beer" className="bottle-beer" />
                              <img src={manufacturing02} alt="Bottle of beer" className="bottle-beer" />
                          </Slider>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  
         
         

              </main>
             <Footer/>
        </section>
    )
}

export default About;